/** TARGET2: Wochenende und die fünf gemeinsamen Feiertage. */

function ostersonntag(jahr) {
  const a = jahr % 19;
  const b = Math.floor(jahr / 100);
  const c = jahr % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const monat = Math.floor((h + l - 7 * m + 114) / 31);
  const tag = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(jahr, monat - 1, tag, 12);
}

function isoOf(tag) {
  const p = (n) => String(n).padStart(2, '0');
  return `${tag.getFullYear()}-${p(tag.getMonth() + 1)}-${p(tag.getDate())}`;
}

export function istBankarbeitstag(tag) {
  if (tag.getDay() === 0 || tag.getDay() === 6) return false;
  const ostern = ostersonntag(tag.getFullYear());
  const verschoben = (tage) => {
    const d = new Date(ostern);
    d.setDate(d.getDate() + tage);
    return isoOf(d);
  };
  const feiertage = new Set([
    `${tag.getFullYear()}-01-01`,
    verschoben(-2),
    verschoben(1),
    `${tag.getFullYear()}-05-01`,
    `${tag.getFullYear()}-12-25`,
    `${tag.getFullYear()}-12-26`,
  ]);
  return !feiertage.has(isoOf(tag));
}

/** Heute, wenn die Bank bucht, sonst der nächste Bankarbeitstag. */
export function fruehesterBankarbeitstag(ab = new Date()) {
  const tag = new Date(ab.getFullYear(), ab.getMonth(), ab.getDate(), 12);
  while (!istBankarbeitstag(tag)) tag.setDate(tag.getDate() + 1);
  return isoOf(tag);
}
